module.exports = __webpack_public_path__ + "img/mission-gfp-farming.jpg?de57fd9fc1ba07082c0e9a62b66b8acd";